export default "__VITE_ASSET__CulDUHOG__"